// Mock data for Solès Immo - warm corporate real estate site

export const agency = {
  name: "SOLÈS IMMO",
  tagline: "Acheter, louer, vendre et gérer, rien que pour vous",
  city: "Boulogne-Billancourt",
  address: "106 route de la Reine",
  zip: "92100 Boulogne-Billancourt",
  phone: "01 41 31 87 00",
  phoneHref: "+33141318700",
  email: "soles.immo@orange.fr",
  hours: [
    { day: "Mardi – Samedi", time: "9h30 – 12h00 / 14h00 – 19h00" },
    { day: "Dimanche & Lundi", time: "Fermé" },
  ],
};

export const legal = {
  fnaim: "Affilié à la caisse de Garantie de la FNAIM : 89 rue La Boétie 75008 PARIS sous le N° 10858C",
  carte: "Carte Professionnelle N° 92012015000002469",
  garanti:
    "Montant garanti : T : 120.000 € — G : 200.000 € — EURL au cap. de 8.000€ — RCS Nanterre 432 341 196",
  copyright: "© " + new Date().getFullYear() + " Solès Immo — Tous droits réservés",
};

export const navLinks = [
  { label: "Accueil", href: "#accueil" },
  { label: "Services", href: "#services" },
  { label: "À propos", href: "#apropos" },
  { label: "Estimation", href: "#estimation" },
  { label: "Quartiers", href: "#quartiers" },
  { label: "Galerie", href: "#galerie" },
  { label: "Actualités", href: "#actualites" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const services = [
  {
    id: "achat",
    title: "Achat",
    icon: "Home",
    text: "Nous vous accompagnons à chaque étape de votre acquisition, de la recherche du bien idéal jusqu'à la signature chez le notaire.",
  },
  {
    id: "vente",
    title: "Vente",
    icon: "Handshake",
    text: "Estimation juste, mise en valeur de votre bien et diffusion ciblée : nous vendons dans les meilleurs délais et conditions.",
  },
  {
    id: "location",
    title: "Location",
    icon: "KeyRound",
    text: "Locataires comme propriétaires, nous sécurisons chaque location avec un accompagnement rigoureux et transparent.",
  },
  {
    id: "gestion",
    title: "Gestion locative",
    icon: "ClipboardCheck",
    text: "Confiez-nous la gestion de votre patrimoine : loyers, entretien, relation locataire, tout est pris en charge sereinement.",
  },
];

export const stats = [
  { value: "30+", label: "Années d'expérience" },
  { value: "FNAIM", label: "Agence affiliée" },
  { value: "1500+", label: "Projets aboutis" },
  { value: "92100", label: "Boulogne-Billancourt" },
];

export const aboutImage =
  "https://images.unsplash.com/photo-1751838024459-5e79145905ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const heroImages = [
  "https://images.unsplash.com/photo-1596615292983-0fd02422e8db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1570911777586-1fab39ca76c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "/images/bb/seine_musicale.jpg",
];

export const team = [
  {
    name: "Antoine Solès",
    role: "Directeur — Agent immobilier",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    phone: "01 41 31 87 00",
  },
  {
    name: "Camille Renaud",
    role: "Conseillère location & gestion",
    img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    phone: "01 41 31 87 00",
  },
  {
    name: "Julien Marchand",
    role: "Conseiller transaction & estimation",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    phone: "01 41 31 87 00",
  },
];

export const gallery = [
  { img: "https://images.unsplash.com/photo-1596615292983-0fd02422e8db?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Immeubles de Boulogne" },
  { img: "https://images.unsplash.com/photo-1570911777586-1fab39ca76c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Architecture haussmannienne" },
  { img: "https://images.unsplash.com/photo-1723547234930-91ba013e1e84?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Quartier résidentiel" },
  { img: "https://images.unsplash.com/photo-1697994391342-dda8bdff0211?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Façades élégantes" },
  { img: "https://images.unsplash.com/photo-1575544333501-4ab6479b5bcc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Bords de Seine" },
  { img: "/images/bb/seine_musicale.jpg", caption: "La Seine Musicale — Île Seguin" },
  { img: "/images/bb/seine_musicale_night.jpg", caption: "La Seine Musicale de nuit" },
  { img: "/images/bb/auditorium.jpg", caption: "L'auditorium en bois" },
];

export const actualites = [
  {
    id: 1,
    title: "Pourquoi faire estimer son bien par un professionnel ?",
    excerpt:
      "Une bonne estimation du prix de vente du logement permet de vendre dans les meilleurs délais et de limiter les marges de négociation des acheteurs.",
    img: "https://images.unsplash.com/photo-1728825445493-1a6e89164511?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    tag: "Estimation",
    date: "12 juin 2025",
  },
  {
    id: 2,
    title: "Locataire : préparez avec soin votre dossier de location",
    excerpt:
      "Fournir le dossier de location le plus complet possible permet d'informer au mieux le propriétaire bailleur de votre situation et de l'aider à réaliser un choix rationnel.",
    img: "https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    tag: "Location",
    date: "28 mai 2025",
  },
  {
    id: 3,
    title: "Vendre son bien : constituer d'abord son dossier",
    excerpt:
      "Pour vendre votre logement dans les meilleurs délais, vous devez détenir certains éléments comme les diagnostics immobiliers et les informations sur la copropriété.",
    img: "https://images.unsplash.com/flagged/photo-1564767609342-620cb19b2357?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    tag: "Vente",
    date: "05 mai 2025",
  },
];

export const trustItems = [
  { id: "fnaim", icon: "Landmark", title: "Agence affiliée FNAIM", text: "Membre de la Fédération Nationale de l'Immobilier et de son code d'éthique." },
  { id: "garantie", icon: "ShieldCheck", title: "Garantie financière", text: "Caisse de Garantie FNAIM — Transaction 120 000 € / Gestion 200 000 €." },
  { id: "carte", icon: "BadgeCheck", title: "Carte professionnelle T & G", text: "N° 92012015000002469 — délivrée par la CCI Paris Île-de-France." },
];

export const quartiers = [
  { id: "billancourt", name: "Billancourt", text: "Le quartier historique autour de la route de la Reine : immeubles anciens, commerces de proximité et vie de village.", tags: ["Route de la Reine", "Commerces", "Familles"] },
  { id: "centre-ville", name: "Centre-ville", text: "Autour de l'Hôtel de Ville et du marché, un secteur recherché pour ses appartements bourgeois et ses services.", tags: ["Hôtel de Ville", "Marché", "Haussmannien"] },
  { id: "marcel-sembat", name: "Marcel-Sembat", text: "Bien desservi par la ligne 9, un quartier vivant et apprécié des actifs comme des investisseurs.", tags: ["Métro ligne 9", "Investissement", "Dynamique"] },
  { id: "pont-de-sevres", name: "Pont de Sèvres", text: "Aux portes de l'Île Seguin et de La Seine Musicale, un secteur en pleine transformation.", tags: ["Île Seguin", "Seine Musicale", "Neuf"] },
  { id: "silly-gallieni", name: "Silly-Gallieni", text: "Calme et résidentiel, prisé pour ses maisons, ses écoles et ses rues arborées.", tags: ["Maisons", "Écoles", "Résidentiel"] },
  { id: "rives-de-seine", name: "Rives de Seine", text: "Le Trapèze et les quais : architecture contemporaine, parc de Billancourt et vues sur la Seine.", tags: ["Trapèze", "Parc", "Vue Seine"] },
];

export const faqs = [
  { q: "Quels sont vos honoraires ?", a: "Nos honoraires sont fixés selon un barème affiché en agence et communiqué sur simple demande. Ils dépendent du type de mandat (vente, location, gestion) et sont toujours annoncés en toute transparence avant tout engagement." },
  { q: "Combien de temps faut-il pour vendre un bien à Boulogne-Billancourt ?", a: "Pour un bien estimé au juste prix, le délai moyen est de 2 à 3 mois jusqu'au compromis, puis environ 3 mois jusqu'à la signature de l'acte authentique chez le notaire." },
  { q: "Quels diagnostics sont obligatoires pour vendre ?", a: "Le dossier de diagnostic technique comprend notamment le DPE, l'amiante, le plomb, l'électricité, le gaz, les termites selon la zone, l'ERP (état des risques) et le mesurage loi Carrez en copropriété. Nous vous accompagnons pour les faire réaliser." },
  { q: "Comment se déroule l'estimation de mon bien ?", a: "Un conseiller visite votre bien, analyse ses atouts et le compare aux ventes récentes de votre quartier. Vous recevez ensuite un avis de valeur argumenté, sans engagement." },
  { q: "Que comprend la gestion locative ?", a: "Recherche et sélection du locataire, rédaction du bail, états des lieux, encaissement des loyers, révisions, régularisation des charges et suivi des travaux : nous gérons votre bien au quotidien." },
  { q: "Quels documents fournir pour louer un logement ?", a: "Pièce d'identité, trois derniers bulletins de salaire, contrat de travail, dernier avis d'imposition et justificatif de domicile. Un dossier complet accélère l'acceptation de votre candidature." },
];
